import { render } from "./spinningLoader.vue?vue&type=template&id=9398d2f0&scoped=true"
import script from "./spinningLoader.vue?vue&type=script&lang=js"
export * from "./spinningLoader.vue?vue&type=script&lang=js"

import "./spinningLoader.vue?vue&type=style&index=0&id=9398d2f0&lang=css&scoped=true"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9398d2f0"]])

export default __exports__